import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function orderList(state = initialState.orders, action) {
    switch (action.type) {

      case types.LOAD_ORDER_REQUEST:
        return Object.assign({}, state, {
          isFetching: true,
        })
      case types.LOAD_ORDER_SUCCESS:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: '',
          data: action.data
        })
      case types.LOAD_ORDER_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: {
            ...action.messages
          }
        })

      case types.LOAD_MORE_ORDER_REQUEST:
        return Object.assign({}, state, {
          isFetchingMore: true
        })
      case types.LOAD_MORE_ORDER_SUCCESS:
        return Object.assign({}, state, {
          isFetchingMore: false,
          errorMessage: '',
          data: {
            ...state.data,
            ...action.data,
            results: [
              ...state.data.results,
              ...action.data.results
            ]
          }
        })
      case types.LOAD_MORE_ORDER_FAILURE:
        return Object.assign({}, state, {
          isFetchingMore: false,
          errorMessage: {
            ...action.messages
          }
        })

      case types.ADD_LIKE_REQUEST:
        return Object.assign({}, state, {
          likeIsFetching: true
        })
      case types.ADD_LIKE_SUCCESS:
        state.data.results.map(order => {
          if(order.id === action.order.id){
            order.likes_count = (action.order.likes_count+1)
            order.is_already_liked = !order.is_already_liked
          }
        });
        return Object.assign({}, state, {
          likeIsFetching: false,
          data: {
            ...state.data
          }
        });

      case types.ADD_DISLIKE_REQUEST:
        return Object.assign({}, state, {
          disLikeIsFetching: true
        })
      case types.ADD_DISLIKE_SUCCESS:
        state.data.results.map(order => {
          if(order.id === action.order.id){
            order.dislikes_count = (action.order.dislikes_count+1)
            order.is_already_disliked = !order.is_already_disliked
          }
        });
        return Object.assign({}, state, {
          disLikeIsFetching: false,
          data: {
            ...state.data
          }
        });

      case types.CREATE_ORDER_REQUEST:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: true,
            updating: true,
          }
        });
      case types.CREATE_ORDER_SUCCESS:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: '',
            data: action.data,
          }
        })
      case types.CREATE_ORDER_FAILED:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: action.messages,
          }
        })

      case types.UPDATE_ORDER_REQUEST:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
           // isFetching: true,
            updating: true,
          }
        });
      case types.UPDATE_ORDER_SUCCESS:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: '',
            data: action.data,
          }
        })
      case types.UPDATE_ORDER_FAILURE:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: action.messages,
          }
        })

      case types.PUBLISH_ORDER_REQUEST:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: true,
            updating: true,
          }
        });
      case types.PUBLISH_ORDER_SUCCESS:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: '',
            data: {
              ...state.orderById.data,
              ...action.data
            }
          }
        })
      case types.PUBLISH_ORDER_FAILURE:
        return Object.assign({}, state, {
          orderById: {
            ...state.orderById,
            isFetching: false,
            updating: false,
            errorMessage: action.messages,
          }
        })

      case types.ADD_RESPONSE_REQUEST:
        return Object.assign({}, state, {
          isFetching: true
        })
      case types.ADD_RESPONSE_SUCCESS:
      //polushit order object i nayti s state-e po id i pomenyat
        state.data.results.map(order => {
          if(order.id === action.order_id) {
            order.is_my_bid = true
          }
        });
        return Object.assign({}, state, {
          isFetching: false,
          data: {
            ...state.data
          }
        });

    case types.LOAD_ORDER_BY_ID_REQUEST:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          isFetching: true,
          updating: action.update
        }
      })
    case types.LOAD_ORDER_BY_ID_SUCCESS:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          updating: false,
          errorMessage: '',
          data: Object.assign({}, state.orderById.data, action.data[0]),
          isFetching: false,
          count: action.count,
        }
      })
    case types.LOAD_ORDER_BY_ID_FAILURE:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          isFetching: false,
          updating: false,
          errorMessage: {
            ...action.messages
          }
        }
      })

    case types.LOAD_EXECUTORS_REQUEST:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          executorById: {
            ...state.orderById.executorById,
            isFetching: true,
          },
        }
      })
    case types.LOAD_EXECUTORS_SUCCESS:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          executorById: {
            ...state.orderById.executorById,
            isFetching: false,
            errorMessage: '',
            data: action.data,
          },
        }
      })
    case types.LOAD_EXECUTORS_FAILURE:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          executorById: {
            ...state.orderById.executorById,
            isFetching: false,
            errorMessage: {
              ...action.messages
            }
          },
        }
      })

    case types.QUIT_ORDER_REQUEST:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          executorById: {
            ...state.orderById.executorById,
            isFetching: true,
          },
        }
      })
    case types.QUIT_ORDER_SUCCESS:
      const quitExecutors = Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          data: {
            ...state.orderById.data,
            is_my_bid: false,
          }
        }
      });
      const quitIndex = state.orderById.executorById.data.results.findIndex(item => item.id === action.executor.id);

      quitExecutors.orderById.executorById.data.results.splice(quitIndex, 1);
      return quitExecutors;

    case types.QUIT_ORDER_FAILURE:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          executorById: {
            ...state.orderById.executorById,
            isFetching: false,
            errorMessage: {
              ...action.messages
            }
          },
        }
      })

    case types.LOAD_EXECUTOR_MESSAGES_SUCCESS:
      const newMessages = Object.assign({}, state);

      const index1 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      newMessages.orderById.executorById.data.results.splice(index1, 1, {
        ...state.orderById.executorById.data.results[index1],
        messages: action.data
      })
      return newMessages

    case types.LOAD_EXECUTOR_MORE_MESSAGES_REQUEST:
      const moreMessagesReq = Object.assign({}, state);

      const index4 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      moreMessagesReq.orderById.executorById.data.results.splice(index4, 1, {
        ...state.orderById.executorById.data.results[index4],
        messages: {
          ...state.orderById.executorById.data.results[index4].messages,
          isFetchingMore: true,
        }
      })
      return moreMessagesReq

    case types.LOAD_EXECUTOR_MORE_MESSAGES_SUCCESS:
      const newMoreMessages = Object.assign({}, state);

      const index3 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      newMoreMessages.orderById.executorById.data.results.splice(index3, 1, {
        ...state.orderById.executorById.data.results[index3],
        messages: {
          ...action.data,
          isFetchingMore: false,
          results: [
            ...action.data.results,
            ...state.orderById.executorById.data.results[index3].messages.results,
          ]
        }
      })
      return newMoreMessages

    case types.LOAD_EXECUTOR_MORE_MESSAGES_FAILURE:
      const moreMessagesFail = Object.assign({}, state);

      const index5 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      moreMessagesFail.orderById.executorById.data.results.splice(index5, 1, {
        ...state.orderById.executorById.data.results[index5],
        messages: {
          ...state.orderById.executorById.data.results[index5].messages,
          isFetchingMore: false,
          errorMessage: action.messages
        }
      })
      return moreMessagesFail

    case types.SEND_MESSAGE_SUCCESS:
      const newMessages2 = Object.assign({}, state);

      const index = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      newMessages2.orderById.executorById.data.results.splice(index, 1, {
        ...state.orderById.executorById.data.results[index],
        messages_count: (state.orderById.executorById.data.results[index].messages_count+1),
        messages: {
          ...state.orderById.executorById.data.results[index].messages,
          count: (state.orderById.executorById.data.results[index].messages.count+1),
          results: [...state.orderById.executorById.data.results[index].messages.results, action.data]
        }
      })
      return newMessages2

    case types.LOAD_EXECUTOR_PHOTOS_SUCCESS:
      const newPhotos = Object.assign({}, state);

      const photoIndex = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      newPhotos.orderById.executorById.data.results.splice(photoIndex, 1, {
        ...state.orderById.executorById.data.results[photoIndex],
        photos: action.data,
      })
      return newPhotos

    case types.LOAD_EXECUTOR_VIDEOS_SUCCESS:
      const newPhotos22 = Object.assign({}, state);

      const photoIndex22 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      newPhotos22.orderById.executorById.data.results.splice(photoIndex22, 1, {
        ...state.orderById.executorById.data.results[photoIndex22],
        videos: action.data,
      })
      return newPhotos22

    case types.UPLOAD_WORK_SUCCESS:
    
      const uploadPhotos = Object.assign({}, state);
      
      const photoIndex2 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      uploadPhotos.orderById.executorById.data.results.splice(photoIndex2, 1, {
        ...state.orderById.executorById.data.results[photoIndex2],
        photos: {
          ...state.orderById.executorById.data.results[photoIndex2].photos,
          results: [
            ...state.orderById.executorById.data.results[photoIndex2].photos.results,
            action.payload,
          ]
        }
      });
     
      return uploadPhotos

    case types.UPLOAD_VIDEO_WORK_SUCCESS:
    
      const uploadVideos = Object.assign({}, state);
      
      const videoIndex2 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      uploadVideos.orderById.executorById.data.results.splice(videoIndex2, 1, {
        ...state.orderById.executorById.data.results[videoIndex2],
        videos: {
          ...state.orderById.executorById.data.results[videoIndex2].videos,
          results: [
            ...state.orderById.executorById.data.results[videoIndex2].videos.results,
            action.payload,
          ]
        }
      });
     
      return uploadVideos

    case types.REMOVE_WORK_PHOTO_SUCCESS:
    
      const uploadPhotosDel = Object.assign({}, state);
      const photoIndex3 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      const photoIndex4 = state.orderById.executorById.data.results[photoIndex3].photos.results.findIndex(item => item.id === action.data.id);
      
      uploadPhotosDel.orderById.executorById.data.results[photoIndex3].photos.results.splice(photoIndex4, 1);
      return uploadPhotosDel

    case types.REMOVE_WORK_VIDEO_SUCCESS:
    
      const uploadPhotosDel2 = Object.assign({}, state);
      const videoIndex3 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      const videoIndex4 = state.orderById.executorById.data.results[videoIndex3].videos.results.findIndex(item => item.id === action.data.id);
      
      uploadPhotosDel2.orderById.executorById.data.results[videoIndex3].videos.results.splice(videoIndex4, 1);
      return uploadPhotosDel2

    case types.SEND_COMPLAINT_SUCCESS:
      const newComplaint = Object.assign({}, state);

      const index2 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      newComplaint.orderById.executorById.data.results.splice(index2, 1, {
        ...state.orderById.executorById.data.results[index2],
        status: 5,
        complaints: [
          action.data,
          ...state.orderById.executorById.data.results[index2].complaints
        ]
      })
      return newComplaint

    case types.ACCEPT_WORK_SUCCESS:
      const accept = Object.assign({}, state);

      const acceptIndex2 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      accept.orderById.executorById.data.results.splice(acceptIndex2, 1, {
        ...state.orderById.executorById.data.results[acceptIndex2],
        status: 4,
      })
      return accept

    case types.EVALUATE_WORK_SUCCESS:
      const evaluate = Object.assign({}, state);

      const evaluateIndex2 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);
      
      evaluate.orderById.executorById.data.results.splice(evaluateIndex2, 1, {
        ...state.orderById.executorById.data.results[evaluateIndex2],
        status: 8,
      })
      return evaluate

    case types.DOWNLOAD_WORK_REQUEST:
      return Object.assign({}, state, {isFetching: true});

    case types.DOWNLOAD_WORK_SUCCESS:
      const downloadState = Object.assign({}, state, {isFetching: false});

      const index6 = state.orderById.executorById.data.results.findIndex(item => item.id === action.bid_id);

      downloadState.orderById.executorById.data.results.splice(index6, 1, {
        ...state.orderById.executorById.data.results[index6],
        link: action.data
      })
      return downloadState
    
    case types.DOWNLOAD_WORK_ERROR:
      return Object.assign({}, state, {isFetching: false});

    case types.CLEAR_BID_USER:
      const clearUserData = Object.assign({}, state, {
        orderById: {
          data: {},
          isFetching: false,
          errorMessage: '',
    
          executorById: {
            data: {
              results: [],
            },
            isFetching: false,
            errorMessage: '',
          }
        }
      });
      return clearUserData;

    case types.ADD_RESPONSE_BY_ID_REQUEST:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          update: true,
        }
      })

    case types.ADD_RESPONSE_BY_ID_SUCCESS:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          update: false,
          data: {
            ...state.orderById.data,
            is_my_bid: true 
          }
        }
      })

    case types.CANCEL_ORDER:
      return Object.assign({}, state, {
        orderById: {
          ...state.orderById,
          data: {
            ...state.orderById.data,
            is_failed: true 
          }
        }
      })
    
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js